<div class="center" *ngIf="loadingTable">
  <mat-spinner></mat-spinner>
</div>
<div *ngIf="!loadingTable" [@fadeIn] >
  <panel heading="{{compartTypeTitle}} Components ({{side}} Side)">
    <table class="table table--full-width grey-bg">
      <thead>
        <tr>
          <th></th>
          <th>Component</th>
          <th>Position</th>
          <th style="text-align: center;">Evaluation</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let component of components">
          <tr>
            <td class="component-cell">
              <div class="component-photo-container"><img class="component-photo" [src]="component.Photo" />
              </div>
            </td>
            <td>{{component.Name}}</td>
            <td>{{component.Position}}</td>
            <td class="table__eval-cell">
              <div  style="display: flex; flex-direction: column;float: right;"> 
                <div style="width: 300px;;">
                  <span class="Eval-{{ component.WornPercentage | wornPercentageToEval}}">{{component.WornPercentage}}%</span>
                </div>
                
                <div style="display: flex; flex-direction: row;">
                  <span style="width: 150px;" *ngIf ="component.CalculatedWorn!=null" class="Eval-{{ component.SUMWorn | wornPercentageToEval}}">{{component.SUMWorn.toFixed(1)}}%</span>
                  <span style="width: 150px;" *ngIf ="component.CalculatedWorn!=null" class="Eval-{{ component.CalculatedWorn | wornPercentageToEval}}">{{component.CalculatedWorn}}%</span>
                </div>
              </div>
              
             
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <div style="float: right; padding-right: 150px;"><span>Include Report</span></div>
              <div class="box-shadow">
                <table class="table table--full-width">
                  <thead>
                    <tr>
                      <th></th>
                      <th class="measurement-point-column">Measurement Point</th>
                      <th>Evaluation</th>
                      <th *ngIf="isAdmin==true">Weighting %</th>
                      <th>Est.</th>
                      <th>Dime. </th>
                      <th>Average Reading ({{uom}})</th>
                      <th>Comment</th>
                      <th>Photos</th>
                      <th>Measure Image</th>
                      <th>Data Table</th>
                      <th>Graph</th>
                      <th>Comments</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let measurementPoint of component.MeasurementPoints">
                      <td class="component-cell">
                        <div class="component-photo-container"><img class="component-photo"
                            [src]="measurementPoint.Photo" (click)="viewPhoto(measurementPoint.Photo)" />
                        </div>
                      </td>
                      <td>{{measurementPoint.Name}}</td>
                      <td class="table__eval-cell">
                        <span *ngIf="shouldShowEval(measurementPoint)"
                          class="Eval-{{ measurementPoint.WornPercentage | wornPercentageToEval}}"
                          (measurementPointUpdated)="childMeasurementPointUpdated()">
                          {{measurementPoint.WornPercentage.toFixed(1)}}% </span>
                      </td>
                      <td  class="table__eval-cell" *ngIf="measurementPoint.ContributionWornPercentage!=null && isAdmin==true">
                        <span class="Eval-{{ measurementPoint.ContributionWornPercentage | wornPercentageToEval}}"
                          (measurementPointUpdated)="childMeasurementPointUpdated()">
                          {{measurementPoint.ContributionWornPercentage.toFixed(1)}}% </span>
                      </td>
                      <td class="table__eval-cell" *ngIf="measurementPoint.ContributionWornPercentage==null && isAdmin==true"> 
                      </td>
                      <td class="table__eval-cell" *ngIf="measurementPoint.HasEstimateMeasurement==true"> 
                        <a> <i class="material-icons" style="font-size: 33px; color: #2d9cdb;" >circle</i> </a>
                      </td>
                      <td class="table__eval-cell" *ngIf="measurementPoint.HasEstimateMeasurement==false"> 
                     
                      </td>

                      <td class="table__eval-cell" *ngIf="measurementPoint.startingEndDim==''"> 
                     
                      </td>
                      <td class="table__eval-cell" *ngIf="measurementPoint.startingEndDim!=''"> 
                        <a> <i class="material-icons" style="font-size: 25px; color: #2d9cdb; cursor: pointer;" title="{{measurementPoint.startingEndDim}}" >info</i> </a>
                      </td>
                      <td class="measurement-cell">
                        <div class="measurement">{{measurementPoint.AverageReading}}</div>
                        <div class="reading"
                          (click)="openReadings(measurementPoint.Readings, component.Id, measurementPoint.CompartMeasurementPointId,measurementPoint.ReportConfigData.CompartTypeId,measurementPoint.ReportConfigData.Id,measurementPoint.ReportConfigData.MiningShovelReportId)">
                          <span class="reading__count">{{measurementPoint.Readings.length}}</span><i
                            class="material-icons reading__icon">keyboard_arrow_down</i></div>
                      </td>
                      <td>
                        <div class="form-item">
                          <div class="form-input">
                            <textarea class="form-textarea" rows="2" autocomplete="off" autocorrect="off"
                              autocapitalize="off" spellcheck="false" [(ngModel)]="measurementPoint.Comment"
                              (change)="updateMeasurementPointComment(measurementPoint.Comment,component.Id, measurementPoint.CompartMeasurementPointId,measurementPoint.ReportConfigData.CompartTypeId,measurementPoint.ReportConfigData.Id,measurementPoint.ReportConfigData.MiningShovelReportId, component.Id)">>
                              </textarea>
                          </div>
                        </div>
                      </td>
                      <td class="photo-cell">
                        <component-photo-small *ngFor="let p of measurementPoint.Photos" [photoId]="p.Id">
                        </component-photo-small>
                        <upload-component-photo (onPhotoUpload)="loadTable()" matTooltip="Upload Photo"
                          [inspectionDetailId]="component.Id"
                          [compartMeasurePointId]="measurementPoint.CompartMeasurementPointId"
                          [ReportId]="measurementPoint.ReportConfigData.Id"
                          [CompartTypeID]="measurementPoint.ReportConfigData.CompartTypeId"
                          [MiningShovelReportId]="measurementPoint.ReportConfigData.MiningShovelReportId"
                         
                          ></upload-component-photo>
                      </td>
                      <td class="centeredtext">
                        <mat-checkbox class="checkbox-margin" [checked]="measurementPoint.ReportConfigData.IncludeMeasurementImage" (change)="toggleIncludes(measurementPoint.ReportConfigData.CompartMeasurementPointId, measurementPoint.ReportConfigData.InspectionDetailId, measurementPoint.ReportConfigData.MiningShovelReportId, measurementPoint.ReportConfigData.MiningShovelReportConfigId, measurementPoint.ReportConfigData.Id, 'IncludeMeasurementImage', $event)"></mat-checkbox>
                      </td>
                      <td class="centeredtext">
                        <mat-checkbox class="checkbox-margin" [checked]="measurementPoint.ReportConfigData.IncludeObservationsTable" (change)="toggleIncludes(measurementPoint.ReportConfigData.CompartMeasurementPointId, measurementPoint.ReportConfigData.InspectionDetailId, measurementPoint.ReportConfigData.MiningShovelReportId, measurementPoint.ReportConfigData.MiningShovelReportConfigId, measurementPoint.ReportConfigData.Id, 'IncludeObservationsTable', $event)"></mat-checkbox>
                      </td>
                      <td class="centeredtext">
                        <mat-checkbox class="checkbox-margin" [checked]="measurementPoint.ReportConfigData.IncludeGraph" (change)="toggleIncludes(measurementPoint.ReportConfigData.CompartMeasurementPointId, measurementPoint.ReportConfigData.InspectionDetailId, measurementPoint.ReportConfigData.MiningShovelReportId, measurementPoint.ReportConfigData.MiningShovelReportConfigId, measurementPoint.ReportConfigData.Id, 'IncludeGraph', $event)"></mat-checkbox>
                      </td>
                      <td class="centeredtext">
                        <mat-checkbox class="checkbox-margin" [checked]="measurementPoint.ReportConfigData.IncludeComments" (change)="toggleIncludes(measurementPoint.ReportConfigData.CompartMeasurementPointId, measurementPoint.ReportConfigData.InspectionDetailId, measurementPoint.ReportConfigData.MiningShovelReportId, measurementPoint.ReportConfigData.MiningShovelReportConfigId, measurementPoint.ReportConfigData.Id, 'IncludeComments', $event)"></mat-checkbox>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="showCalculatedFields">
          <td colspan="4">
            <div class="box-shadow">
              <calculated-fields [a]="calcA" [b]="calcB" [c]="calcC" [d]="calcD"></calculated-fields>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </panel>
</div>
